import React from "react";
import Search from "./Search";

function Discover(){
    return(
        <>
        <div className="w-auto justify-center items-center bg-gray-800 shadow-lg flex flex-col drop-shadow-lg bg-opacity-75 my-4 relative ">
            <h1 className="border-b-2 text-white text-3xl mb-4" id="whoobe-3mr7n">Discover</h1>
            <Search menuOption={0} setQuery={()=>{return}}/>
        </div>
        </>
    )
}
export default Discover